export default "__VITE_ASSET__9b76b7fd__"